/**
 *
 * @export
 * @class InfographicHelper
 */
export class InfographicHelper {
    public lightboxImage: string | null = null;

    public zoomImage(image: string): void {
        if (this.lightboxImage === image) {
            this.lightboxImage = null;
        } else {
            this.lightboxImage = image;
        }
    }

    public closeLightbox(): void {
        this.lightboxImage = null;
    }
}
